import { gql } from '__generated__';

export const ACCEPT_AI_POLICY = gql(/* GraphQL */ `
  mutation AcceptAiPolicy($version: String!) {
    acceptAiPolicy(version: $version) {
      success
      error
      acceptedVersion
    }
  }
`);
